import { render, staticRenderFns } from "./BannerModelBclass.vue?vue&type=template&id=1edca228&scoped=true&"
import script from "./BannerModelBclass.vue?vue&type=script&lang=js&"
export * from "./BannerModelBclass.vue?vue&type=script&lang=js&"
import style0 from "./BannerModelBclass.vue?vue&type=style&index=0&id=1edca228&prod&scoped=true&lang=css&"
import style1 from "./BannerModelBclass.vue?vue&type=style&index=1&id=1edca228&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edca228",
  null
  
)

export default component.exports